/**
 * Close Modal
 */
const closeQuickshopModal = () => {
  $(document).on(
    "click",
    ".js-modal-close-quickshop, .quickshop .js-ajax-add",
    function (event) {
      // Empty the fields in the quickshop modal so we don't see
      // old data when we open a new modal

      $("#quickshop .quickshop__content").html(`
      <div class="quickshop__close js-modal-close js-modal-close-quickshop"></div>
      <div class="loader" id="quickshop-loading"></div>
      <div class="section-product section-product--hidden"></div>
    `);

      $("#quickshop").removeClass("is-open");
      if (
        $(".drawer.is-active").length > 0 ||
        $(".modal-aside.expanded").length > 0
      ) {
        return;
      } else {
        $("body").removeClass("no-scroll");
      }
    }
  );
};

closeQuickshopModal();
